<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/CompanyProfile'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fab fa-product-hunt"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="cplKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อโปรไฟล์ ชื่อคลัง ชื่อตัวแทนจำหน่าย ชื่อร้านค้า โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'cplAgentCode'"
                    :name="'cplAgentCode'"
                    :select2-options="cplAgentCodeOptions"
                    v-model="cplAgentCode"
                    ref="cplAgentCodeSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทโปรไฟล์บริษัท:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'cplProfileTypeCode'"
                    :name="'cplProfileTypeCode'"
                    :select2-options="cplProfileTypeCodeOptions"
                    v-model="cplProfileTypeCode"
                    ref="cplProfileTypeCodeSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'cplInActiveStatus'"
                    :name="'cplInActiveStatus'"
                    :select2-options="cplInActiveStatusOptions"
                    v-model="cplInActiveStatus"
                    ref="cplInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="CompanyProfile/Add"
                  tag="button"
                  title="เพิ่มข้อมูลโปรไฟล์บริษัท"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow([
                      'MANAGE_MASTER',
                      'MANAGE_COMPANY_PROFILE',
                    ])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลโปรไฟล์บริษัท
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="custProfileTable"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th class="all">ชื่อโปรไฟล์บริษัท</th>
                    <th class="all">ประเภทโปรไฟล์บริษัท</th>
                    <th class="all">บริษัท</th>
                    <th class="all">สถานะ</th>
                    <th class="none">ตัวแทนจำหน่าย</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#custProfileTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/CompanyProfile/" + this.data.id + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#custProfileTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/CompanyProfile/" + this.data.id + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editCompanyProfile" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="deleteCompanyProfile" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    editCompanyProfile: function() {
      router.push({
        path: `/Master/CompanyProfile/Edit/${this.data.id}`,
      });
    },
    deleteCompanyProfile: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลโปรไฟล์บริษัท",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลโปรไฟล์บริษัท <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้โปรไฟล์บริษัทนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลโปรไฟล์บริษัทออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/CompanyProfile/" + this.data.id + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      cplInActiveStatus: null,
      cplKeyword: null,
      cplProfileTypeCode: null,
      cplAgentCode: null,

      // Configurations
      cplProfileTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "COMPANY_PROFILE_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cplInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      cplAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      //default Active Data
      this.cplInActiveStatus = false;
      $("#cplInActiveStatus")
        .val(this.cplInActiveStatus + "")
        .trigger("change");

      $("#cplProfileTypeCode")
        .val("")
        .trigger("change");

      $("#cplAgentCode")
        .val("")
        .trigger("change");

      this.cplKeyword = null;

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#custProfileTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#custProfileTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.cplInActiveStatus = false;
    $("#cplInActiveStatus")
      .val(self.cplInActiveStatus + "")
      .trigger("change");
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#custProfileTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/CompanyProfile/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                CompanyType: self.cplProfileTypeCode,
                InActiveStatus: self.cplInActiveStatus,
                SearchKeyword: self.cplKeyword,
                AgentCode: self.cplAgentCode,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[6, "desc"]],
        columns: [
          {
            data: null,
            className: "details-control",
            defaultContent: "",
            orderable: false,
          },
          { data: "profileName" },
          { data: "profileTypeName", className: "text-center" },
          { data: "companyName", className: "text-center",

          render: function(data, type, full, meta) {
              var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>"+data+"</pre>";
              return html;
            }
           },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          { data: "agentMappingStringFormat", className: "text-center" },
          {
            data: "id",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_COMPANY_PROFILE",
            ]);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_COMPANY_PROFILE",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_COMPANY_PROFILE",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/CompanyProfile/CompanyProfileList.vue